"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value === null || value === undefined;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isNil.js
// module id = 720
// module chunks = 0